import { render, staticRenderFns } from "./SurveyQuestionsList.vue?vue&type=template&id=838e263e"
import script from "./SurveyQuestionsList.vue?vue&type=script&lang=js"
export * from "./SurveyQuestionsList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports